import { Clock } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { STORIES } from "@/lib/site";

export default function StoriesSection() {
  return (
    <section className="bg-ivory py-24 lg:py-32" data-testid="stories-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Journal · Newsroom"
          title="Stories from the Ground"
          sub="Real stories from our Congo work, field visits and events are on the way. The journey is just beginning."
        />
        <div className="mt-14 grid gap-8 md:grid-cols-3" data-testid="stories-grid">
          {STORIES.map((story, i) => (
            <Reveal key={story.title} delay={i * 0.1}>
              <article className="group h-full overflow-hidden rounded-2xl border border-hairline bg-white shadow-sm transition-shadow duration-300 hover:shadow-xl" data-testid={`story-card-${i + 1}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={story.img} alt={story.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  {story.comingSoon !== false && (
                    <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-charcoal/80 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-ivory backdrop-blur" data-testid={`story-coming-soon-badge-${i + 1}`}>
                      <Clock className="h-3 w-3 text-gold" /> Coming soon
                    </span>
                  )}
                </div>
                <div className="p-7">
                  <p className="eyebrow text-ochre">{story.category}</p>
                  <h3 className="mt-3 font-display text-xl font-semibold leading-snug text-forest sm:text-2xl">{story.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mutedink">{story.excerpt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
